import tableRelatedCountries from './tableRelatedCountries';

export default {
  title: 'Available Countries',
  attributeName: 'available_in_countries',
  getURL: 'countriesPaginate',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  tableConfig: tableRelatedCountries,
};